import { RequestBuilder } from "@lernetz/request";

export function normalizeRelative(path: string) {
  // verifiy starting /
  path = startSlash(path);

  // remove multiple ///
  return path.replace(/\/+/g, "/");
}

export function normalizeAbsolute(path: string) {
  path = normalizeRelative(path);
  // interpret ../ and ./ in path
  path = new RequestBuilder(path).url;

  // trim trailing slash
  return path.endsWith("/") ? path.substring(0, path.length - 1) : path;
}

export function trimLeft(base: string, full: string) {
  // remove trailing slash
  if (base.endsWith("/")) base = base.substring(0, base.length - 1);

  return full.indexOf(base) == 0 ? full.substring(base.length) : full;
}

export function startSlash(path: string) {
  return path.startsWith("/") ? path : "/" + path;
}
